import { render } from "./restyle_alert.vue?vue&type=template&id=b615e764"
import script from "./restyle_alert.vue?vue&type=script&lang=js"
export * from "./restyle_alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__